import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationInput } from '@challenger/care//components/confirmation/confirmation.model';
import { StrapiGenericComponentService } from '@challenger/care/services/strapi-generic-component.service';
import { SEOFlowService, FlowResult, ERROR } from '../../services/seo-flow.service';
import {
  ComponentElementsGlobalComponent,
  FaultArticle,
} from '@challenger/care/modules/graphql/generated/graphql-types';
import { AppLoadingService } from '../../../common/services/app-loading.service';
import { HeaderVariant } from '@challenger/care/components/header-wrapper/header.types';

@Component({
  selector: 'vm-seo-flow-shell',
  templateUrl: './seo-flow-shell.component.html',
  styleUrls: ['./seo-flow-shell.component.scss'],
})
export class SEOFlowShellComponent implements OnInit {
  articleContent: ConfirmationInput;
  adviceContent = {
    backRoute: '',
    doneRoute: '',
    items: [],
  };

  constructor(
    private strapiGenericComponentService: StrapiGenericComponentService,
    private seoFlowService: SEOFlowService,
    private route: ActivatedRoute,
    private router: Router,
    private appLoadingService: AppLoadingService
  ) {
    router.onSameUrlNavigation = 'reload';
  }

  ngOnInit(): void {

    this.appLoadingService.setTheme(HeaderVariant.secondary);

    const strapiPrefix = this.route.snapshot.paramMap.get('strapiPrefix')?.toLowerCase() || '';
    const strapiUID = this.route.snapshot.paramMap.get('strapiUID')?.toLowerCase() || '';
    const pageType = this.route.snapshot.paramMap.get('pageType')?.toLowerCase() || '';

    // A url determine the strapi Uid e.g. 'pairing-the-remote/360/many-more' to 'pairing-the-remote_360_many-more'
    const strapiUIDUrl = strapiUID?.replace(/_/g, '/');
    const wfPath = `/help/how-to/guides/${strapiPrefix}/${strapiUIDUrl}/${pageType}`;

    let wfiPrevious: FaultArticle;
    let wfiCurrent: FaultArticle;
    let wfiNext: FaultArticle;

    this.seoFlowService.getWorkflowArticles(strapiPrefix, strapiUID).subscribe(
      (flowResult: FlowResult) => {
        const wfArticles = this.seoFlowService.formatWorkflowArticles(flowResult, strapiPrefix, strapiUID);

        wfArticles.forEach((article: FaultArticle, index) => {
          if (
            (article.elements[0] as ComponentElementsGlobalComponent).genericComponent[0].externalUrl
              ?.toLowerCase()
              .endsWith(wfPath?.toLowerCase())
          ) {
            wfiCurrent = article;
            wfiNext = index < wfArticles.length ? wfArticles[index + 1] : null;
            wfiPrevious = index > 0 ? wfArticles[index - 1] : null;
          }
        });

        if (!wfiCurrent) {
          wfiCurrent = wfArticles[0];
        }
        if (
          (wfiCurrent.elements[0] as ComponentElementsGlobalComponent).genericComponent[0]?.genericElementType?.uid ===
          'carouselSection'
        ) {
          this.adviceContent.backRoute = (
            wfiPrevious.elements[0] as ComponentElementsGlobalComponent
          ).genericComponent[0].externalUrl;
          this.adviceContent.doneRoute = (
            wfiNext.elements[0] as ComponentElementsGlobalComponent
          ).genericComponent[0].externalUrl;
          this.adviceContent.items = this.strapiGenericComponentService.formatAdviceContent(wfiCurrent).items;
        } else {
          this.articleContent = this.strapiGenericComponentService.formatArticleContent(wfiCurrent);
        }
        this.appLoadingService.showLoading(false);
      },
      (err) => {
        if (err.message === ERROR.PAGE_NOT_FOUND) {
          this.router.navigateByUrl('/page-not-found');
        }
      }
    );
  }
}
